// <elova-rastreio> — progressive enhancement for blocks/elova-rastreio.liquid.
//
// Without JS the "Rastrear" link simply opens https://www.melhorrastreio.com.br/.
// With JS the code the customer pasted is normalised (trimmed, uppercased,
// every space stripped) and appended to the link's data-base, so the tab opens
// straight on https://www.melhorrastreio.com.br/rastreio/{CODE}, which detects
// the carrier itself. An empty input cancels the navigation and shows the
// inline error from locales (elova.rastreio.error_empty).

class ElovaRastreio extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('[data-rastreio-input]');
    this.link = this.querySelector('[data-rastreio-link]');
    this.error = this.querySelector('[data-rastreio-error]');
    if (!this.input || !this.link || !this.error) return;

    this.link.addEventListener('click', (event) => this.track(event));
    this.input.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      this.track(event);
    });
    this.input.addEventListener('input', () => this.clearError());
  }

  normalise() {
    return this.input.value.replace(/\s+/g, '').toUpperCase();
  }

  track(event) {
    const code = this.normalise();
    if (!code) {
      event.preventDefault();
      this.showError();
      return;
    }

    this.input.value = code;
    this.clearError();
    const url = this.link.dataset.base + encodeURIComponent(code);

    if (event.type === 'click') {
      // Let the anchor's own default action open it (target=_blank, rel=noopener).
      this.link.href = url;
      return;
    }
    window.open(url, '_blank', 'noopener');
  }

  showError() {
    this.error.textContent = this.error.dataset.message || '';
    this.input.setAttribute('aria-invalid', 'true');
    this.input.focus();
  }

  clearError() {
    this.error.textContent = '';
    this.input.removeAttribute('aria-invalid');
  }
}

if (!customElements.get('elova-rastreio')) {
  customElements.define('elova-rastreio', ElovaRastreio);
}
